import { Component, OnInit, SimpleChange } from '@angular/core';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs/Rx';
import { NetworkService }  from '../network.service';
import { Router } from '@angular/router';
import { NetworkConstants } from '../network-constants';
import { getNetworkListingDatatableConfig } from './network-listing.dt.config';
import { JobsNotifierService } from '../../../../../services/job-notifier.service';
import { JobConstants } from '../../../../../../common/utils/job-constants';
import { Response } from '@angular/http';
import { RefreshSharedService } from '../../../../../refresh-shared-service';
const NETWORK: string = 'network';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { AuthService } from '../../../../../auth/auth.service';
const _ = require('lodash');

@Component({
    selector: 'network-listing',
    template: require('./network-listing.html'),
    styles: [require('./network-listing.scss')],
    providers: [ NetworkService ]
})

export class NetworkListing implements OnInit {
    selectedNetwork: any = null;
    subscribeHandler: Subscription;
    showDeleteDialog: boolean = false;
    computeContainers: any[];
    canAddNetwork: boolean = true;
    canEditNetwork: boolean = false;
    canDeleteNetwork: boolean = false;
    private timer = null;
    private tableSettings: Object = {};
    private tableConfig: Object = {};
    private isNetworkCallInProgress: boolean = false;
    private networkOperationFailed: boolean = false;
    private errorMessage: string = '';
    private showFailureDialog: boolean = false;
    private failureReasons: string = '';
    private canShowFailures: boolean = false;
    private jobCompletionSubscription: Subscription;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private isSystemAdmin: boolean = false;
    private isEnterpriseAdmin: boolean = false;
    private disableDeleteButton: boolean = false;

    constructor(private networkService: NetworkService,
                public authService: AuthService,
                private router: Router,
                private jobNotifierService: JobsNotifierService,
                private refreshService: RefreshSharedService,
                private translate: TranslateService) {

        translate.onLangChange.subscribe((event) => {
        });
        translate.use(GlobalVariables.LOCALE);
        this.tableConfig = getNetworkListingDatatableConfig();
        Object.assign(this.tableSettings, this.tableConfig, {'data': []});
        this.jobCompletionSubscription = this.jobNotifierService.
        getCompletedJobs(JobConstants.SERVICES['NetworkingLifecycleJob']).subscribe(jobs => {
                this.refreshNetworks(jobs);
            },
            error => {},
            () => {}
        );
        this.currentClassName = 'NetworkListing';
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }
        if (_.includes(roles, 'Enterprise Administrator')) {
            this.isEnterpriseAdmin = true;
        }
    }

    ngOnInit() {
        this.getComputeContainers();
        this.refreshService.setParam({
          'loadedComponent': this.currentClassName,
          'detailPageIDName': '',
          'shouldReloadInventoryTree': false
        })
        this.refreshSubscription = this.refreshService.getRefreshParam()
        .subscribe (
            item => {
            this.handleRefresh(item);
        });
    }

    handleRefresh(refreshItem) {
        if (refreshItem.loadedComponent === this.currentClassName) {
            this.networkService.networks = [];
            this.getAllNetwork();
        }
    }
    onNetworkSelection(event) {
        if (event && event.value && event.value instanceof Array ) {
           if (event.value[0]) {
                this.selectedNetwork = event.value[0];
                let networkId = this.selectedNetwork.objectId ? this.selectedNetwork.objectId : this.selectedNetwork.id;
                this.subscribeHandler = this.networkService.getPermissions(networkId)
                        .subscribe(
                        (permission:any) => {
                            this.canAddNetwork = permission.ADD;
                            this.canEditNetwork = (this.isSystemAdmin ) ? true : permission.EDIT_IPSCOPES ||  permission.EDIT;
                            this.canDeleteNetwork = (this.isSystemAdmin ) ? true : permission.DELETE;
                            this.canShowFailures = this.isItinFailedState(this.selectedNetwork);
                        },
                        error => {
                            this.canAddNetwork = true;
                            this.canEditNetwork = true;
                            this.canDeleteNetwork = true;
                            this.canShowFailures = false;
                        }
                );
           } else {
               this.selectedNetwork = null;
               this.canAddNetwork = true;
               this.canEditNetwork = false;
               this.canDeleteNetwork = false;
               this.canShowFailures = false;
           }
        }
    }

    onEdit(event: any) {
        let selectedNetwork = this.selectedNetwork;
        if (typeof selectedNetwork.ownedBySystem === "undefined" || !selectedNetwork.ownedBySystem) {
            this.showEditNetworkDialog();
            return;
        }
        this.showEditImportNetworkDialog();
    }

    onCreate() {
        this.router.navigate(['services/networking/network/new']);
    }

    showImportNetworkDialog() {
        if (this.isSystemAdmin) {
            this.router.navigate(['services/networking/network/import']);
        }
    }

    showEditNetworkDialog() {
        let url: string = 'services/networking/network/edit/' + this.selectedNetwork.objectId;
        this.router.navigate([url]);
    }

    showEditImportNetworkDialog() {
        if (this.isSystemAdmin || this.isEnterpriseAdmin) {
            let url = 'services/networking/network/edit-import/' + this.selectedNetwork.objectId;
            this.router.navigate([url])
        }
    }


    getAllNetwork() {
        this.networkService.autoRefreshNetworks.attempt = 0;
        this.networkService.getAllNetworks();
    }

    onDelete() {
        this.isNetworkCallInProgress = true;
        this.disableDeleteButton = true;
        this.subscribeHandler = this.networkService.deleteNetwork(this.selectedNetwork.objectId)
            .subscribe(
            networks => {
                this.getAllNetwork();
                this.isNetworkCallInProgress = false;
                this.showDeleteDialog = false;
                this.disableDeleteButton = false;
            },
            error => {
                this.handleNetworkOpreationError(error);
            },
            () => this.logOperationCompleted('get network operations succeeded')
        );
    }

    logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
    }

    logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
    }

    onNetworkUpsertOpration(name: string) {
        this.getAllNetwork();
    }

    getComputeContainers(){
        this.subscribeHandler = this.networkService.getComputeContainer()
            .subscribe(
            (containers:any) => {
                this.computeContainers = containers;
                this.getAllNetwork();
            },
            error => this.logError(error, 'get all networks'),
            () => this.logOperationCompleted('get all networks')
        );
    }

    getComputeContainer(scopeId) {
        for ( let i = 0; i<this.computeContainers.length; ++i){
            let computeContainer = this.computeContainers[i];
            if (computeContainer.scopeId === scopeId){
                return computeContainer.name;
            }
        }
    }

    isItinFailedState(network): boolean {
        if (!network) {
            return false;
        }
        if (network.state === NetworkConstants.STATE.NOT_REALIZED || network.state === NetworkConstants.STATE.ERROR) {
            return true;
        }
        return false;
    }

    handleNetworkOpreationError(error: any ) {
        this.networkOperationFailed = true;
        this.isNetworkCallInProgress = false;
        const errorResponse = error;
        // in some cases the web layer spits out exception directly to api response.
        // in such scenarios the error message will be present at message property of response
        this.errorMessage = errorResponse.errorMessage || errorResponse.message;
    }

    onDeleteCancel(event) {
        this.showDeleteDialog = false;
        this.networkOperationFailed = false;
        this.isNetworkCallInProgress = false;
        this.disableDeleteButton = false;
    }

    onDeleteDialogClose(event) {
         if (!event) {
            this.onDeleteCancel(event);
        }
    }

    onShowshowFailureDialogClosed(event) {
        if (!event) {
            this.onFailureDialogCancel();
        }
    }

    onFailureDialogCancel() {
        this.showFailureDialog = false;
        this.failureReasons = '';
    }

    onShowFailure(event) {
        this.showFailureDialog = true;
        this.isNetworkCallInProgress = true;
        let networkId = this.selectedNetwork.objectId ? this.selectedNetwork.objectId : this.selectedNetwork.id;
        this.subscribeHandler = this.networkService.getNetwork(networkId)
        .subscribe(
            (network:any) => {
                this.isNetworkCallInProgress = false;
                this.failureReasons = network.jobDetails.errorMessage;
            },
            error => this.handleNetworkOpreationError(error)
        );
    }

    refreshNetworks(jobs) {
        let workflowType: string;
        for (let index: number = 0; index < jobs.length; ++index) {
            workflowType = jobs[index].workflowType;
            if (workflowType.indexOf('NETWORK') !== -1) {
                this.networkService.getAllNetworks();
                break;
            }
        }
    }

    ngOnDestroy(){
        if (this.subscribeHandler) {
            this.subscribeHandler.unsubscribe();
        }

        this.refreshService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }

        if (this.jobCompletionSubscription) {
            this.jobCompletionSubscription.unsubscribe();
            this.jobNotifierService.unsubscribeService(JobConstants.SERVICES['NetworkingLifecycleJob']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/listing/network-listing.component.ts